import styled from "styled-components";

export const ModalBackground = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  height: 100%;
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
  z-index: 2;
  padding: 32px;
  gap: 32px;
  width: 560px;

  @media screen and (max-width: 680px) {
    width: 90%;
    top: 25%;
  }
`;

export const ModalContent = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  padding-top: 0;
  width: 100%;
`;

export const Title = styled.span`
  color: #000;
  text-align: center;
  font-family: "InterTight-Bold", Helvetica;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.5px;
`;

export const Description = styled.p`
  color: #000;
  text-align: center;
  font-family: "InterTight-Bold", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.2px;
`;

export const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 24px;
`;
